import { createClient } from '@supabase/supabase-js';

// Replace with your Supabase URL and anon key (NOT the service role key)
const supabaseUrl = 'https://dxxiecticdemyvtudmum.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR4eGllY3RpY2RlbXl2dHVkbXVtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA4NDM1NDksImV4cCI6MjA1NjQxOTU0OX0.lTmdUj-U2Pp0NWv0nuljuAEW4yrXLtp3Z0QbKzdJY38'; // Replace with your anon key

export const supabase = createClient(supabaseUrl, supabaseKey);